module.exports = __webpack_public_path__ + "static/media/banner.61f31984.png";